export default "__VITE_ASSET__991974b1__"